<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          واحدها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>

        <v-row>

          <v-col cols="12"
                 sm="12"
                 md="3"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                clearable
                @click:clear="fillDataItems"
                placeholder="نام واحد"
                v-model="searchValue"
            />
            <v-btn fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="3"
                 md="3"
                 class="d-inline-flex"
          >

            <v-file-input
                outlined
                dense
                prepend-icon=""
                v-model="file"
                show-size
                label="اکسل نام واحدها "
                :error-messages="getError('file')"
            ></v-file-input>
            <v-btn fab small color="warning" @click="saveByExcel" class="mr-1">
              <v-icon>mdi-cloud-upload</v-icon>
            </v-btn>

          </v-col>
          <v-col class="d-sm-inline-block" cols="12" sm="12"
                 md="6">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>


        <v-spacer/>

        <v-spacer/>
        <b-table
            v-if="can('unitList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            striped
        >
          <!--          <template #cell(index)="row">-->
          <!--            <label>{{ (row.index+1)+(skip*take)}}</label>-->
          <!--          </template>-->
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import Unit_se from "./Unit_se";
import {mapMutations} from "vuex";


export default {
  name: 'Unit',
  data() {
    return {
      searchValue: '',
      modelId: '',
      dataItems: [],
      bindingErrors: [],
      file: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'unitName', label: 'نام',},
        {key: 'caption', label: 'نام جهت نمایش',},
        {key: 'building.name', label: 'مجتمع',},

      ],

    };

  },


  methods: {

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    close() {
      this.searchValue = ''
      this.$router.push('/building')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
      this.modelAtributes = (Unit_se.getPage(this.skip - 1, this.take, this.modelId).then(response => {
        this.dataItems = response.data.unitList
        this.paging = response.data.page
        this.search()

      }));
    },

    search() {
      if (this.searchValue.length > 0) {
        Unit_se.search(this.searchValue, this.modelId, this.skip - 1, this.take).then(result => {
          if (result.data.check) {
            this.paging = result.data.page
          }
          this.dataItems = result.data.unitList
        })
      }
    },
    saveByExcel() {
      this.bindingErrors = []
      this.$progress({message: 'درحال ذخیره اطلاعات...'}, true)
      Unit_se.saveByExcel(this.file,this.modelId).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.$snack({type: 'success', message: 'درحال ذخیره اطلاعات...'})
        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.$snack({type: 'error', message: response.response.data})
          this.bindingErrors = response.response.data;
        }
      })
    },
  },

  created() {
    this.setDrawer(false)
    this.modelId = this.$route.query.id
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
